<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D; flex-shrink: 0;">{{ esUpdate ? 'edit' : 'person_add' }}</mat-icon>
    <h2 style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">
      {{ esUpdate ? 'Actualizar beneficiario Zelle' : 'Nuevo beneficiario Zelle' }}
    </h2>
  </div>
  <button type="button" (click)="cancel()"
    style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
    onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 20px 24px; overflow-y: auto; max-height: calc(90vh - 140px);">
  <form [formGroup]="beneficiarioForm!" (ngSubmit)="guardarCuentaZelle()">

    <!-- Banco destino -->
    <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Banco destino</mat-label>
        <mat-select formControlName="bancoDestino">
          <mat-option value="" disabled>Seleccione banco</mat-option>
          <mat-option *ngFor="let banco of bancos" [value]="banco.codigoBanco">{{ banco.nombre }}</mat-option>
        </mat-select>
        <mat-error *ngIf="beneficiarioForm?.get('bancoDestino')?.hasError('required')">Banco es requerido</mat-error>
      </mat-form-field>
    </div>

    <!-- Tipo de beneficiario -->
    <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Tipo de beneficiario</mat-label>
        <mat-select formControlName="tipoBeneficiario" (selectionChange)="resetIdentificador()">
          <mat-option value="" disabled>Seleccione tipo de beneficiario</mat-option>
          <mat-option value="0">Individuo</mat-option>
          <mat-option value="1">Empresa</mat-option>
        </mat-select>
        <mat-error *ngIf="beneficiarioForm?.get('tipoBeneficiario')?.hasError('required')">Tipo de beneficiario es requerido</mat-error>
      </mat-form-field>
    </div>

    <!-- Nombre / Razón social -->
    <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>{{ getPlaceholder() }}</mat-label>
        <input matInput formControlName="nombreApellido" type="text"
          pattern="[a-zA-Z0-9 À-ÿ]*"
          [placeholder]="getPlaceholder()"
          (keypress)="soloLetras($event)">
        <mat-error *ngIf="beneficiarioForm?.get('nombreApellido')?.hasError('required')">Nombre del beneficiario es requerido</mat-error>
      </mat-form-field>
    </div>

    <!-- Identificador (Zelle) -->
    <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;" *ngIf="beneficiarioForm?.get('bancoDestino')?.value === 'ZELLE'">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Teléfono o Email</mat-label>
        <input matInput formControlName="identificador" type="text"
          placeholder="Número de teléfono o Email"
          (keypress)="identifier($event)"
          (input)="onInput($event)">
        <mat-error *ngIf="beneficiarioForm?.get('identificador')?.hasError('required')">Identificación del beneficiario es requerida</mat-error>
        <mat-error *ngIf="beneficiarioForm?.get('identificador')?.hasError('invalidEmail')">Debe ser un correo electrónico válido</mat-error>
        <mat-error *ngIf="beneficiarioForm?.get('identificador')?.hasError('invalidPhone')">Debe ser un número de teléfono válido</mat-error>
        <mat-error *ngIf="beneficiarioForm?.get('identificador')?.hasError('minLength')">El número de teléfono debe tener al menos 10 dígitos</mat-error>
      </mat-form-field>
    </div>

    <!-- Número de cuenta (BOFA y otros) -->
    <div class="grid grid-cols-1 gap-4" style="margin-bottom: 8px;" *ngIf="beneficiarioForm?.get('bancoDestino')?.value !== 'ZELLE'">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Número de cuenta</mat-label>
        <input matInput formControlName="numeroCuenta" type="text" placeholder="Número de cuenta">
        <mat-error *ngIf="beneficiarioForm?.get('numeroCuenta')?.hasError('required')">Campo requerido</mat-error>
        <mat-error *ngIf="beneficiarioForm?.get('numeroCuenta')?.hasError('minlength') || beneficiarioForm?.get('numeroCuenta')?.hasError('maxlength')">Debe contener de 8 a 12 caracteres</mat-error>
      </mat-form-field>
    </div>

  </form>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap;">
  <button type="button" (click)="cancel()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <button type="button" (click)="guardarCuentaZelle()"
    [disabled]="!beneficiarioForm?.valid"
    [style.opacity]="!beneficiarioForm?.valid ? '0.5' : '1'"
    [style.cursor]="!beneficiarioForm?.valid ? 'not-allowed' : 'pointer'"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">save</mat-icon>
    {{ esUpdate ? 'Actualizar' : 'Agregar Beneficiario' }}
  </button>
</div>
